export function getFiltersValues(filters = {}) {
  const currentFilters = Object.entries(filters);
  if (!currentFilters.length) {
    return [];
  }
  const filterValues = currentFilters.filter(
    ([key, value]) => value !== undefined && value !== null && value !== ""
  );
  return filterValues;
}

export function shouldShowFiltersLabels(filters = {}) {
  const currentFilters = Object.entries(filters);
  const filterValues = currentFilters.filter(
    ([key, value]) =>
      value !== undefined &&
      value !== null &&
      value !== "" &&
      value !== "customClientParameters" &&
      key !== "customClientParameters"
  );

  return filterValues.filter(Boolean).length;
}

export function shouldShowFiltersLabelsMultipleSearchWatchList(filters = {}) {
  const currentFilters = Object.entries(filters);
  const filterValues = currentFilters.filter(
    ([key, value]) =>
      value !== undefined &&
      value !== null &&
      value !== "" &&
      JSON.stringify(value) !== "[]"
  );

  return filterValues.filter(Boolean).length;
}

export function getFiltersValuesMonitoringQueue(filters = {}) {
  const currentFilters = Object.entries(filters);
  if (!currentFilters.length) {
    return [];
  }

  const filterValues = currentFilters.filter(
    ([key, value]) => value !== undefined && value !== null && value !== ""
  );

  return filterValues;
}

export function trimFormData(data = {}) {
  for (const key in data) {
    if (typeof data[key] === "string") {
      data[key] = data[key].trim();
    } else if (typeof data[key] === "object" && data[key] !== null) {
      data[key] = trimFormData(data[key]);
    }
  }
  return data;
}



// WEBPACK FOOTER //
// ./src/utilities/filters.js